import PropTypes from 'prop-types'
import React from 'react'
import { FormattedNumber } from 'react-intl'
import { Vignette } from 'components/Vignette'
import { View } from 'components/View'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import { getOptionsProductUtil } from 'models/daos/product/utils/get-options'
import { PRODUCT_MODEL_KEY } from 'models/daos/product/constants'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { getImagesProductUtil } from 'models/daos/product/utils/get-images'
import TextBody from 'components/TextBody'
import TextBodySmall from 'components/TextBodySmall'
import getPriceStringUtil from 'utils/string/get-price'
import {
  capitalizeStringUtil,
  getObjectUtil
} from 'packages/src'

class ProductRowSummary extends React.Component {
  getImage () {
    let image
    const { product } = this.props
    const option = getObjectUtil(this.props.data, 'option')
    if (option) {
      const options = getOptionsProductUtil(product)
      const selectedImageIndex = options.findIndex((o) => o === option)
      if (selectedImageIndex !== -1) {
        image = getImagesProductUtil(product)[selectedImageIndex]
      }
    }
    return (
      image ||
      getValueReduxUtil(product, PRODUCT_MODEL_KEY.IMG)
    )
  }

  renderBody () {
    return (
      <View
        style={{
          textAlign: 'left'
        }}
      >
        {this.renderQuantityName()}
        {this.renderPrice()}
        {this.renderData()}
      </View>
    )
  }

  renderData () {
    const { data } = this.props
    if (!data) {
      return
    }
    return (
      <>
        {
          Object.keys(data).map((key) => {
            const value = data[key]
            return (
              <TextBodySmall key={key}>
                {`${capitalizeStringUtil(key)}: ${capitalizeStringUtil(value)}`}
              </TextBodySmall>
            )
          })
        }
      </>
    )
  }

  renderImage () {
    return (
      <View
        style={{
          height: '100%',
          marginRight: STYLES_MARGIN.SMALL
        }}
      >
        <Vignette
          name={(
            getValueReduxUtil(
              this.props.product,
              PRODUCT_MODEL_KEY.NAME
            )
          )}
          width={this.props.size}
          source={this.getImage()}
        />
      </View>
    )
  }

  renderPrice () {
    return (
      <TextBodySmall>
        <span>
          <span>Price: </span>
          <FormattedNumber
            currency={this.props.currency}
            style='currency'
            value={getPriceStringUtil(this.props.price)}
          />
        </span>
      </TextBodySmall>
    )
  }

  renderQuantityName () {
    const name = getValueReduxUtil(this.props.product, PRODUCT_MODEL_KEY.NAME)
    return (
      <TextBody>
        {`${this.props.quantity} x ${name}`}
      </TextBody>
    )
  }

  render () {
    return (
      <View
        style={{
          flexDirection: View.DIRECTION.ROW,
          alignItems: View.ALIGN.CENTER
        }}
      >
        {this.renderImage()}
        {this.renderBody()}
      </View>
    )
  }
}

ProductRowSummary.SIZE = Vignette.SIZE
ProductRowSummary.defaultProps = {
  quantity: 1,
  size: ProductRowSummary.SIZE.BIGGEST
}
ProductRowSummary.propTypes = {
  product: PropTypes.object.isRequired,
  price: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  quantity: PropTypes.number,
  size: PropTypes.oneOf(
    Object.values(ProductRowSummary.SIZE)
  )
}

export default ProductRowSummary
